module.exports = __webpack_public_path__ + "static/media/bookmark-check.23e0885a.svg";